import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statItems = [
    {
      icon: 'Users',
      label: 'Total Trainers',
      value: stats?.totalTrainers,
      color: 'var(--color-primary)'
    },
    {
      icon: 'Star',
      label: 'Avg Rating',
      value: stats?.avgRating,
      color: 'var(--color-warning)'
    },
    {
      icon: 'Calendar',
      label: 'Sessions Today',
      value: stats?.sessionsToday,
      color: 'var(--color-accent)'
    },
    {
      icon: 'Award',
      label: 'Specialties',
      value: stats?.specialties,
      color: 'var(--color-success)'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-xl shadow-md p-4 md:p-5 transition-smooth hover-lift"
        >
          <div className="flex items-center gap-3 mb-2">
            <div
              className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg"
              style={{ backgroundColor: `${item?.color}15` }}
            >
              <Icon name={item?.icon} size={20} color={item?.color} strokeWidth={2} />
            </div>
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-1 data-text">
            {item?.value}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground caption">{item?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;